import type { ReportDateRangeFilter } from 'src/api/generated';
import { ReportDateRangePreset } from 'src/api/generated';

/**
 * Shared input styling for dashboard setup controls.
 */
export const REPORT_WIDGET_INPUT_CLASSES =
  'w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-primary-900 shadow-sm focus:border-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-200';

/**
 * Supported date presets for report widgets.
 */
export const REPORT_DATE_PRESET_OPTIONS: Array<{
  value: ReportDateRangeFilter['preset'];
}> = [
  { value: ReportDateRangePreset.TODAY },
  { value: ReportDateRangePreset.LAST_7_DAYS },
  { value: ReportDateRangePreset.THIS_MONTH },
  { value: ReportDateRangePreset.LAST_30_DAYS },
  { value: ReportDateRangePreset.CUSTOM_RANGE },
];
